<template>
  <div class="pagination-wrapper">
    <div class="pagination-info">
      <div
        v-if="meta"
        class="pagination-info-counts">
        <template v-if="meta.total > 0">
          {{ $t('common.pagination.infoCounts', { from: meta.from, to: meta.to, total: meta.total }) }}
        </template>
        <template v-else>
          {{ $t('common.pagination.infoCountsEmpty') }}
        </template>
      </div>
      <div
        v-if="activeFilters"
        class="pagination-info-filters">
        <strong>{{ $t('common.pagination.activeFilters') }}</strong>
      </div>
    </div>

    <div class="pagination">
      <a
        v-if="hasPrev()"
        href="#"
        class="pagination-prev"
        @click.prevent="goBack">
        ◀&#xFE0E;
      </a>

      <div class="pagination-content">
        {{ $t('common.pagination.page') }}
        <input
          type="number"
          v-model="currentPage"
          min="1"
          :max="max"
          @change="goTo" />
        {{ $t('common.pagination.from', {max}) }}
      </div>

      <a
        v-if="hasNext()"
        href="#"
        class="pagination-next"
        @click.prevent="goNext">
        ▶&#xFE0E;
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'pagination',
  props: {
    activeFilters: {
      type: Boolean,
      required: true
    },
    current: {
      type: Number,
      required: true
    },
    max: {
      type: Number,
      required: true
    },
    meta: {
      type: [Object, Boolean],
      required: true
    },
    onChange: {
      type: Function,
      required: true,
      default: () => false
    }
  },
  data () {
    return {
      currentPage: this.current
    };
  },
  methods: {
    hasPrev () {
      return this.currentPage > 1;
    },
    hasNext () {
      return this.currentPage < this.max;
    },
    goBack () {
      this.currentPage -= 1;
      this.onChange(this.currentPage);
    },
    goNext () {
      this.currentPage = parseInt(this.currentPage, 10) + 1;
      this.onChange(this.currentPage);
    },
    goTo () {
      if (this.currentPage < 1) {
        this.currentPage = 1;
      }

      if (this.currentPage > this.max) {
        this.currentPage = this.max;
      }

      this.onChange(this.currentPage);
    },
    reset () {
      this.currentPage = 1;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.pagination {
  align-items: center;
  display: flex;
  user-select: none;

  &-wrapper {
    display: flex;
    justify-content: flex-end;
    margin: 0 auto;
    max-width: 1400px;
    padding: 0 0 4rem 0;
    width: 100%;
  }

  &-prev,
  &-next {
    background: $color-light;
    border: 1px solid $color-border;
    border-radius: $border-radius-small 0 0 $border-radius-small;
    color: $color-text-light;
    font-size: 1rem;
    height: 3.6rem;
    line-height: 3.7rem;
    padding: 0 1.2rem 0 1rem;
  }

  &-next {
    border-radius: 0 $border-radius-small $border-radius-small 0;
    padding: 0 1rem 0 1.2rem;
  }

  &-content {
    background: $color-bg-medium-alt;
    align-items: center;
    border: 1px solid $color-border;
    border-radius: $border-radius-small;
    display: flex;
    font-size: 1.4rem;
    height: 3.6rem;
    margin: 0 -.4rem;
    padding: 0 1rem;

    input {
      border: 1px solid $color-border;
      border-radius: $border-radius-small;
      margin: 0 .5rem;
      padding: .25rem 0;
      text-align: center;
      width: 5rem;
    }
  }

  &-info {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    margin-right: auto;

    &-counts,
    &-filters {
      font-size: 1.3rem;
      width: 100%;
    }

    &-counts {

    }

    &-filters {

    }
  }
}

@media (max-width: 1480px) {
  .pagination-wrapper {
    margin: 0 2rem;
    max-width: calc(100% - 4rem);
  }
}

@media (max-width: 640px) {
  .pagination-wrapper {
    flex-wrap: wrap;
    justify-content: center;

    .pagination-info {
      padding: 1rem 0 2rem 0;
      text-align: center;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/Pagination.vue